import { CheckoutState } from '../../state';
import {
    getWidgetParentUrl,
    isAndroidApp,
    isEventbriteTLD,
    isIosApp,
} from './';

export const getIsEmbeddedInOrganizerSite = (state: CheckoutState) =>
    !!(
        !isIosApp(state) &&
        !isAndroidApp(state) &&
        !isEventbriteTLD(state) &&
        getWidgetParentUrl(state)
    );
